import { Link } from "react-router-dom";
import { Ghost } from "lucide-react";
import { PublicLayout } from "../components/Common";

export default function NotFound() {
  return (
    <PublicLayout>
      <div className="min-h-[60vh] grid place-items-center text-center px-4">
        <div>
          <span className="grid place-items-center h-16 w-16 rounded-2xl bg-indigo-50 text-indigo-600 mx-auto mb-5"><Ghost className="h-8 w-8" /></span>
          <p className="font-heading text-6xl font-extrabold text-slate-900">404</p>
          <h1 className="font-heading text-xl font-bold text-slate-900 mt-2">Halaman Tidak Ditemukan</h1>
          <p className="text-slate-500 mt-1 mb-6">Maaf, halaman yang Anda cari tidak tersedia.</p>
          <Link to="/" className="btn-primary">Kembali ke Beranda</Link>
        </div>
      </div>
    </PublicLayout>
  );
}
